import { render, staticRenderFns } from "./priceFilterModal.vue?vue&type=template&id=cd537d92&"
import script from "./priceFilterModal.vue?vue&type=script&lang=js&"
export * from "./priceFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports